import React, { useEffect, useState } from "react";
import {useNavigate } from "react-router-dom";
import AuthService from "../../services/AuthService";
import TwoFAService from "../../services/twoFAService";
import QRCodeGenerator from "../ClinicContainer/QrCode";
import { OK } from "../../utils/constant";
import Card from "../../components/UI/Card";
import { Input } from "postcss";
import FormInputs from "../../components/UI/FormInputs";

const TwoFactorAuth = () => {
  const navigate = useNavigate();
  const [qrCode, setQrCode] = useState(null);
  const [isQrCodeModal, setQrCodeModal] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [authData,setAuthData]=useState([])
  const [timer, setTimer] = useState(120);  // Timer starts at 120 seconds
  const [isTimerActive, setIsTimerActive] = useState(false);  // Flag to control timer
  const [canResend, setCanResend] = useState(false);  // Control if "Resend Code" can be shown
  const [resendCount, setResendCount] = useState(() => {
          const storedCount = sessionStorage.getItem("resendCount");
          return storedCount ? parseInt(storedCount, 10) : 0;
      });
  useEffect(()=>{
    if(!AuthService.getProfileId()){ //edge Caase for not profile iD
      navigate('/');
      return;
    }
    if(AuthService.is2FAVerified()){ //edge Case for already verified
      navigate('/');
    }
    fetchUserData()
  },[])
  const fetchUserData=async()=>{
   const id=  AuthService.getProfileId()
   try{
   const response = await TwoFAService.GetVerifcicationData(id);
      if (response ) {
        console.log("ressss",response);
        let filterdata=response
        if(response.length>0){
          filterdata=response.filter((item)=> item.enabled)
        }
        if(filterdata.length===1){
          if(filterdata[0].method ==='app'){
            setMessage("Verification code has been sent to your Authentication App")
            setSelectedMethod(filterdata[0].method)
            try {
              const payload={
                'user_id':AuthService.getProfileId(),
                'method':filterdata[0].method,
              }
              const response = await TwoFAService.getTwoFALoginCode(payload);
              if (response ) {
                setTimer(120)
                setIsTimerActive(true)
                console.log(response.qr_code);
                setQrCode(response.qr_code);
              }
            } catch (err) {
              setError("An error occurred while requesting the verification code.");
            }
          }else{
            try {
              const payload={
                'user_id':AuthService.getProfileId(),
                'method':filterdata[0].method,
              }
              const response = await TwoFAService.getTwoFALoginCode(payload);
            
          } catch (err) {
            setError("An error occurred while requesting the verification code.");
          }
            setMessage("Verification code has been sent through "+capitalize(filterdata[0].method))
            setTimer(120)
            setIsTimerActive(true)
            setSelectedMethod(filterdata[0].method)
          }
        }
        setAuthData(filterdata)
      }
    }catch(err){
      console.log(err);
      
    }
  }
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  const handleMethodChange = async (e,item) => {
    const selected = e.target.checked;
    setTimer(120)
    setIsTimerActive(true)
    setSelectedMethod(item.method);
  
    if(item.method==='app'){
      // setQrCode()
      setMessage(`Verification code has been sent to your Authentication ${capitalize(item.method)}`);
    }else{
      setMessage(`Verification code has been sent to your ${capitalize(item.method)}`);
    setQrCode(null);
    }
    setCode("")
    setError("");
    try {
      const payload={
        'user_id':AuthService.getProfileId(),
        'method':item.method,
      }
      const response = await TwoFAService.getTwoFALoginCode(payload);
      if (response && response.message) {
         console.log(response);
      }
      if (item.method === "app") {
        console.log(response.qr_code);
        setQrCode(response.qr_code);
    }
    
    } catch (err) {
      setError("An error occurred while requesting the verification code.");
    }
  };
  const handleVerificationCode=(value)=>{
    setError("")
    const regex =value.replace(/[^0-9]/g, '');
    if(regex.length <= 6 ){
      setCode(regex)}
}

  const handleVerify = async () => {
    if (!code) {
      setError("Please enter the verification code.");
      return;
    }
    try {
      const payload={
        'user_id':AuthService.getProfileId(),
        method: selectedMethod,
        code
      };
      const response=await AuthService.verifyTwoFactor(payload);
      console.log(response,'response');
      if (response.code==OK) {
        AuthService.store2FAverifed(true);
        navigate('/'); // Redirect after successful 2FA verification
      } else {
        setError("Invalid code. Try again.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    }
  };
      useEffect(() => {
          let interval;
          if (isTimerActive && timer > 0) {
              interval = setInterval(() => {
                  setTimer(prev => prev - 1);
              }, 1000);
          }
          if (timer === 0) {
              clearInterval(interval);
              setCanResend(true);
          }
  
          // Clean up interval if the timer is not active or the component is unmounted
          return () => clearInterval(interval);
      }, [isTimerActive, timer,resendCount]);
  const handleResend = async (event) => {
    setResendCount((prevCount) => {
        const newCount = prevCount + 1;
        sessionStorage.setItem("resendCount", newCount); // Save to sessionStorage
        return newCount;
    });
    if(resendCount >=5){
        await lockUserAccount();
        return;
    }
    setTimer(120);
    setIsTimerActive(true);
    setCanResend(false);
    // await handleSubmit(event);
};
    const lockUserAccount = async () =>{
        try{
            // setLoading(true);
            const payload = {
                user_id: AuthService.getProfileId(),
                is_block: true,
            };
            await TwoFAService.lockUserAccount(payload);
            localStorage.clear();
            sessionStorage.clear();
            setError('Maximum resend code exceeded Your account is locked. Please contact admin to unlock.');
        }catch(error){
            console.error('Error locking user account:', error);
            // alert("An error occurred. Please try again.");
        }
    }
  const handleReturnLogin = async () =>{
    AuthService.logout();
    AuthService.store2FAverifed(true);
    navigate('/login');
  };

  return (
    <>
        {
            isQrCodeModal ?
            <QRCodeGenerator
            qrCodeDetails={{ link: qrCode, clinicName: "MyApp" }}
            modleToogleHandler={()=>setQrCodeModal(!isQrCodeModal)}
            />
            :
            ''
        }
    <div className="row justify-content-center">
              <div className="col-lg-6 min-vh-100 d-flex flex-column justify-content-center mx-auto">
                <div className="row">
                  <div className="col-md-9 mx-auto">
                    <Card className="sh_loginCard o-hidden border-0 my-5 shadow_new">
                        <div className="row">
                          <div className="col-lg-12">
                         
                            <div className="text-center sh_loginLogo">
                            <img src="/assets/img/snap-logo-new.png" className="w-100" alt="logo"/>
                            </div>
                            <h6 className="fw-light mb-0 pt-1">Two-Factor Authentication</h6>
                            <div className="small mb-2 text-muted">Select a method to receive the verification code:</div>
                              <div className="form-group mb-2 row align-items-center justify-content-between">
                              {message && <div className="mx-2 text-success p-1 col-12">{message}</div>}
                            <div className="col-12 d-flex fn_authradiobtnbox"> {authData.length===1?
                                   authData.map((item ,index)=>{
                                    return  <div className="fn_authradiobtn d-flex align-items-center" key={index}><input type="radio" name="auth-method" checked={true} onChange={(e)=>handleMethodChange(e,item.method)} ></input> <label>{item.method==='app'?'Auth App':capitalize(item.method)}</label>
                        
                                            </div>
                                  })
                              :
                              authData.map((item ,index)=>{
                                return  <div className="fn_authradiobtn d-flex align-items-center" key={index}><input type="radio" name="auth-method" onChange={(e)=>handleMethodChange(e,item)} ></input> <label>{item.method==='app'?'Auth App':capitalize(item.method)}</label>

                                        </div>
                              })}
                              {/* <input type="radio" ></input> <label>Authenticator App</label>
                              <input type="radio" ></input> <label>Email</label>
                              <input type="radio" ></input> <label>SMS</label> */}
                                {/* <select className="form-control form-control-fields" onChange={handleMethodChange} value={selectedMethod}>
                                  <option value="">-- Select Method --</option>
                                  <option value="app">Authenticator App</option>
                                  <option value="email">Email</option>
                                  <option value="sms">SMS</option>
                                </select> */}
                                </div> 
                                </div>

                                {selectedMethod && (
                                  <>
                                                                  
                                    <div className="form-group mb-2">
                                   
                                    <input
                                      type="text"
                                      placeholder="Enter verification code"
                                      className = "form-control form-control-fields"
                                      value={code}
                                      onChange={(e) => handleVerificationCode(e.target.value)}
                                    />
                                       {error && <span className="text-danger">{error}</span>}
                                </div>
                                <div className="my-2 d-flex align-items-center justify-content-center">
                                {selectedMethod === 'app' && 
                                    <div className="text-right "><button className=" btn  fn_authqrbtn" onClick={()=>setQrCodeModal(true)}>Show the QR Code</button></div>}
                                {isTimerActive && selectedMethod !== "app" && (                           
                                <p className="mb-0">Time remaining: {timer} seconds</p>
                           )} 
                        {canResend && (
                                <a href="#" className="btn btn-link" onClick={handleResend}>Resend Code</a>
                        )}
                            </div>
                                    <div class="form-group ">
                                      <div class="d-flex align-items-center sh_loginButtons justify-content-between">
                                          <a class="btn btn-primary btn-user" style={{cursor:"pointer"}} onClick={handleVerify} >
                                            Verify</a>
                                          <a class="btn btn-primary btn-user" onClick={handleReturnLogin} style={{cursor:"pointer"}}>Return to Login</a>
                                      </div>
                                  </div>
                                  </>
                                )}

    
                              <div className="form-group ">
                                <div className="d-flex align-items-center sh_loginButtons justify-content-between">
                                  
                                </div>
                              </div>
 
                          </div>
                        </div>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
    </>
  );
};

export default TwoFactorAuth;
